<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
import DevicePixelRatio from '@/utils/DevicePixelRatio.js';
export default {
  name: 'App',
  mounted() {
    new DevicePixelRatio().init();
    var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
    var scale = devicewidth / 1920; // 分母——设计稿的尺寸
    document.body.style.zoom = scale;//放大缩小相应倍数
    window.addEventListener('unload', () => {
      sessionStorage.removeItem('homeSwiperIndex')
      sessionStorage.removeItem('newsData')
    });
    window.oncontextmenu = function () {
      return false;
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
#app {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .esp_text {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue